import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PromotionMessageService} from '../../../../../../services/promotion/promotion-message.service';
import {PromotionMessageModel, PromotionMessageWizardModel} from '../../../../../../models/promotion-message.model';

@Component({
  selector: 'app-tab-message',
  template: `
    <form (ngSubmit)="saveFirstTab(false)" [formGroup]="form">
      <div class="ui-g form-group master-data">
        <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'promotion.code', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="code" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.description', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="description" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.discountType', md: '6' }">
            <p-dropdown formControlName="discount_type_id" [options]="discountTypes" [filter]="true"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'promotion.discountAmt', md: '6' }">
            <input type="number" min="0" pInputText formControlName="discount_amt" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.couponType', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="coupon_type"
              maxlength="1"/>
          </div>
          <div [kv-form-element]="{ label: 'promotion.notes', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="notes" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.barCodeType', md: '6' }">
            <p-dropdown formControlName="barcode_type_pid" [options]="barCodes" [filter]="true"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'promotion.barCode', md: '6' }">
            <input
              type="text"
              pInputText
              formControlName="barcode"/>
          </div>
          <div [kv-form-element]="{ label: 'promotion.cluster', md: '4' }">
            <p-dropdown formControlName="cluster_id" [options]="clusters" [filter]="true"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: '', md: '1' }"></div>
          <div [kv-form-element]="{ label: 'promotion.daysFromEmission', md: '2' }">
            <input type="number" min="0" pInputText formControlName="days_from_emission" />
          </div>
          <div [kv-form-element]="{ label: '', md: '1' }"></div>
          <div [kv-form-element]="{ label: 'promotion.typeMessage', md: '4' }">
            <p-dropdown formControlName="type_message_id" [options]="messagesTypes" [filter]="true" [style]="{'width':'100%' }"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'promotion.stretchValue', md: '6' }">
            <input type="number" min="0" pInputText formControlName="stretch_value" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.thresholdValue', md: '6' }">
            <input type="number" min="0" pInputText formControlName="threshold_value" />
          </div>
          <div [kv-form-element]="{ label: 'promotion.template', md: '4' }">
            <p-dropdown formControlName="fe_template_id" [options]="templates" [filter]="true"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'promotion.redemptionTemplate', md: '4' }">
            <p-dropdown formControlName="redemption_template_id" [options]="templates" [filter]="true"></p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'promotion.emissionTemplate', md: '4' }">
            <p-dropdown formControlName="emission_template_id" [options]="templates" [filter]="true"></p-dropdown>
          </div>
          <div class="ui-g-12">
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
            <div style="text-align: center" [kv-form-element]="{ label: 'promotion.fidelity', md: '2' }">
              <p-inputSwitch formControlName="flg_fidelity"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
            <div style="text-align: center" [kv-form-element]="{ label: 'promotion.cardHolder', md: '2' }">
              <p-inputSwitch formControlName="flg_card_holder"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
            <div style="text-align: center" [kv-form-element]="{ label: 'promotion.openCoupon', md: '2' }">
              <p-inputSwitch formControlName="flg_open_coupon"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: '', md: '1' }"></div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <button
          pButton
          type="submit"
          class="k-generic-btn"
          icon="fa fa-save"
          label="{{'common.save' | translate}}">
        </button>
      </div>
      <div class="text-right">
        <button 
          *ngIf="shortInsert"
          pButton type="button"
          class="k-generic-btn"
          icon="fa fa-angle-left"
          iconPos="left"
          label="{{ 'promotion.saveAndBackToDetail' | translate }}"
          (click)="saveFirstTab(true)">
        </button>
      </div>
    </form>
  `,
  styleUrls: ['./tabMessage.component.css']
})
export class TabMessageComponent implements OnInit, OnChanges {

  @Input() messageConfigs: PromotionMessageWizardModel[];
  @Input() discountTypes;
  @Input() selectedWizard;
  @Input() wizards;
  @Input() messagesTypes;
  @Input() barCodes;
  @Input() clusters;
  @Input() templates;
  @Input() editMessage;
  @Input() shortInsert;

  @Output() saveMessage = new EventEmitter();
   @Output() saveMessageAndBack = new EventEmitter();

  form: FormGroup;
  arrayMerged: PromotionMessageWizardModel[];
  defaultMessageConfig: PromotionMessageWizardModel[] = [
    {
      name: 'type_message_id',
      mandatory: true
    },
    {
      name: 'flg_fidelity',
      mandatory: true
    },
    {
      name: 'code',
      mandatory: true
    }
  ];

  constructor(private fb: FormBuilder,
              private svcMessage: PromotionMessageService) {}

  ngOnInit(): void {}

  private createForm(exist = false, editMessage: PromotionMessageModel = null) {

    this.arrayMerged = this.svcMessage.mergeConfigs(this.defaultMessageConfig, this.messageConfigs);

    if (!exist) {
      this.form = this.fb.group({
        'wizard_id': {value: this.selectedWizard, disabled: true},
        'code': this.svcMessage.createField('code', this.arrayMerged),
        'description':  this.svcMessage.createField('description', this.arrayMerged),
        'type_message_id': this.svcMessage.createField('type_message_id', this.arrayMerged, null),
        'discount_type_id': this.svcMessage.createField('discount_type_id', this.arrayMerged),
        'discount_amt': this.svcMessage.createField('discount_amt', this.arrayMerged, 0),
        'coupon_type': this.svcMessage.createField('coupon_type', this.arrayMerged),
        'notes': this.svcMessage.createField('notes', this.arrayMerged),
        'cluster_id': this.svcMessage.createField('cluster_id', this.arrayMerged),
        'flg_fidelity': this.svcMessage.createField('flg_fidelity', this.arrayMerged, null, true),
        'flg_card_holder': this.svcMessage.createField('flg_card_holder', this.arrayMerged, null, true),
        'barcode_type_pid': this.svcMessage.createField('barcode_type_pid', this.arrayMerged),
        'barcode': this.svcMessage.createField('barcode', this.arrayMerged),
        'flg_open_coupon': this.svcMessage.createField('flg_open_coupon', this.arrayMerged, null, true),
        'days_from_emission': this.svcMessage.createField('days_from_emission', this.arrayMerged),
        'stretch_value': this.svcMessage.createField('stretch_value', this.arrayMerged),
        'threshold_value': this.svcMessage.createField('threshold_value', this.arrayMerged),
        'fe_template_id': this.svcMessage.createField('fe_template_id', this.arrayMerged),
        'redemption_template_id': this.svcMessage.createField('redemption_template_id', this.arrayMerged),
        'emission_template_id': this.svcMessage.createField('emission_template_id', this.arrayMerged),
      });
    } else {
      this.form = this.fb.group({
        'wizard_id': {value: this.selectedWizard, disabled: true},
        'code': this.svcMessage.createField('code', this.arrayMerged, editMessage.code),
        'description':  this.svcMessage.createField('description', this.arrayMerged, editMessage.description),
        'type_message_id': this.svcMessage.createField('type_message_id', this.arrayMerged, editMessage.type_message_id),
        'discount_type_id': this.svcMessage.createField('discount_type_id', this.arrayMerged, editMessage.discount_type_id),
        'discount_amt': this.svcMessage.createField('discount_amt', this.arrayMerged, editMessage.discount_amt !== null && editMessage.discount_amt ? editMessage.discount_amt : 0),
        'coupon_type': this.svcMessage.createField('coupon_type', this.arrayMerged, editMessage.coupon_type),
        'notes': this.svcMessage.createField('notes', this.arrayMerged,  editMessage.notes),
        'cluster_id': this.svcMessage.createField('cluster_id', this.arrayMerged, editMessage.cluster_id),
        'flg_fidelity': this.svcMessage.createField('flg_fidelity', this.arrayMerged, editMessage.flg_fidelity),
        'flg_card_holder': this.svcMessage.createField('flg_card_holder', this.arrayMerged, editMessage.flg_card_holder),
        'barcode_type_pid': this.svcMessage.createField('barcode_type_pid', this.arrayMerged, editMessage.barcode_type_pid),
        'barcode': this.svcMessage.createField('barcode', this.arrayMerged, editMessage.barcode),
        'flg_open_coupon': this.svcMessage.createField('flg_open_coupon', this.arrayMerged, editMessage.flg_open_coupon),
        'days_from_emission': this.svcMessage.createField('days_from_emission', this.arrayMerged, editMessage.days_from_emission),
        'stretch_value': this.svcMessage.createField('stretch_value', this.arrayMerged, editMessage.stretch_value),
        'threshold_value': this.svcMessage.createField('threshold_value', this.arrayMerged, editMessage.threshold_value),
        'fe_template_id': this.svcMessage.createField('fe_template_id', this.arrayMerged, editMessage.fe_template_id),
        'redemption_template_id': this.svcMessage.createField('redemption_template_id', this.arrayMerged, editMessage.redemption_template_id),
        'emission_template_id': this.svcMessage.createField('emission_template_id', this.arrayMerged, editMessage.emission_template_id)
      });
    }
  }

  saveFirstTab(back = false) {
    if (!back) {
      let saveThisMessage: PromotionMessageModel = {
        id: this.editMessage !== null ? this.editMessage.id : null,
        wizard_id: this.form.controls['wizard_id'].value,
        code: this.form.controls['code'].value,
        description:  this.form.controls['description'].value,
        type_message_id: this.form.controls['type_message_id'].value,
        discount_type_id: this.form.controls['discount_type_id'].value,
        discount_amt: this.form.controls['discount_amt'].value,
        coupon_type: this.form.controls['coupon_type'].value,
        notes: this.form.controls['notes'].value,
        cluster_id: this.form.controls['cluster_id'].value,
        flg_fidelity: this.form.controls['flg_fidelity'].value,
        flg_card_holder: this.form.controls['flg_card_holder'].value,
        barcode_type_pid: this.form.controls['barcode_type_pid'].value,
        barcode: this.form.controls['barcode'].value,
        flg_open_coupon: this.form.controls['flg_open_coupon'].value,
        days_from_emission: this.form.controls['days_from_emission'].value,
        stretch_value: this.form.controls['stretch_value'].value,
        threshold_value: this.form.controls['threshold_value'].value,
        fe_template_id: this.form.controls['fe_template_id'].value,
        redemption_template_id: this.form.controls['redemption_template_id'].value,
        emission_template_id: this.form.controls['emission_template_id'].value
      };
      this.saveMessage.emit(saveThisMessage);
    } else {
      let saveThisMessage: PromotionMessageModel = {
        id: this.editMessage !== null ? this.editMessage.id : null,
        wizard_id: this.form.controls['wizard_id'].value,
        code: this.form.controls['code'].value,
        description:  this.form.controls['description'].value,
        type_message_id: this.form.controls['type_message_id'].value,
        discount_type_id: this.form.controls['discount_type_id'].value,
        discount_amt: this.form.controls['discount_amt'].value,
        coupon_type: this.form.controls['coupon_type'].value,
        notes: this.form.controls['notes'].value,
        cluster_id: this.form.controls['cluster_id'].value,
        flg_fidelity: this.form.controls['flg_fidelity'].value,
        flg_card_holder: this.form.controls['flg_card_holder'].value,
        barcode_type_pid: this.form.controls['barcode_type_pid'].value,
        barcode: this.form.controls['barcode'].value,
        flg_open_coupon: this.form.controls['flg_open_coupon'].value,
        days_from_emission: this.form.controls['days_from_emission'].value,
        stretch_value: this.form.controls['stretch_value'].value,
        threshold_value: this.form.controls['threshold_value'].value,
        fe_template_id: this.form.controls['fe_template_id'].value,
        redemption_template_id: this.form.controls['redemption_template_id'].value,
        emission_template_id: this.form.controls['emission_template_id'].value
      };
      this.saveMessageAndBack.emit(saveThisMessage);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editMessage'].currentValue === null) {
      this.createForm();
    } else {
      this.createForm(true, changes['editMessage'].currentValue);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/message/components/tab/message/tabMessage.component.ts